const dev = {
  api: {
    baseURL: 'https://api.staging.get-a-way.com',
    apiVersion: '1.1.20',
  },
};

const prod = {
  api: {
    baseURL: 'https://api.get-a-way.com',
    apiVersion: '1.1.20',
  },
};

const config = process.env.VITE_STAGE === 'production' ? prod : dev;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...config,
};
